const DEFAULT_LOCATION_ZOOM = 5;

export const buildCoordinateChartUrl = ([lat, lon], zoom = DEFAULT_LOCATION_ZOOM) =>
  `/charts/@${lat},${lon},${zoom}z`;

export const getCoordinateChartsUrl = coordinates => buildCoordinateChartUrl(coordinates);

export const getLocationChartPath = (node) => {
  const coordinates = node && node.location && node.location.coordinates;
  if (!coordinates || coordinates.length < 2) {
    return null;
  }
  const [lon, lat] = coordinates;
  const zoom = node.zoom == null ? DEFAULT_LOCATION_ZOOM : node.zoom;
  return buildCoordinateChartUrl([lat, lon], zoom);
};

export const getLocationMenuPath = (node, slug) => {
  if (node) {
    const chartPath = getLocationChartPath(node);
    if (chartPath) {
      return chartPath;
    }
  }
  const locationSlug = (node && node.slug) || slug;
  return `/map/${locationSlug}`;
};



// WEBPACK FOOTER //
// ./src/utils/urls/chartUrls.js